import { getAuth } from "firebase/auth";
import { NavigationGuardNext, RouteLocation, RouteLocationNormalized } from "vue-router";

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  const queryInviteToken = Array.isArray(to.query.token) ? to.query.token[0] : to.query.token;
  const paramInviteToken = Array.isArray(to.params.token) ? to.params.token[0] : to.params.token;
  const inviteToken = queryInviteToken || paramInviteToken;
  if (to.name === "invite" && typeof inviteToken === "string" && inviteToken.trim()) {
    sessionStorage.setItem("pendingInviteToken", inviteToken.trim());
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const redirectRecord = to.matched.find((record) => record.meta.redirectAuth);
  const { meta } = redirectRecord || {};
  const auth = getAuth();
  const { currentUser } = auth;
  if (currentUser && redirectRecord) {
    if (to.query.lang) {
      localStorage.setItem("lang", to.query.lang as string);
    }
    next({ name: meta?.redirectAuth } as RouteLocation);
  } else if (requiresAuth && !currentUser) {
    next({ name: "login" });
  } else {
    next();
  }
};
